module.exports = __webpack_public_path__ + "static/img/mpqr1.18ba177.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/mpqr1.jpeg
// module id = ybj7
// module chunks = 0